var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header-width divcss5"},[_c('productdetailbanner')],1),_vm._v(" "),_c('div',{staticClass:"row body-width divcss5"},[_c('zncyheader')],1),_vm._v(" "),_c('div',{staticClass:"row body-width divcss5"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-730b2184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productzncy.vue
// module id = null
// module chunks = 